import { initReactI18next } from 'react-i18next';
import i18n, { InitOptions } from 'i18next';
import LngDetector from 'i18next-browser-languagedetector';
import resourcesToBackend from 'i18next-resources-to-backend';
import { loadTranslations } from '@justgiving/page-components';

export const initI18n = async () =>
  i18n
    .use(initReactI18next)
    .use(
      resourcesToBackend(
        async (lang: string, namespace: string) =>
          (await loadTranslations(lang, namespace)) ??
          (await import(
            /* webpackChunkName: "lang/[request]" */ `../lang/${lang}/${namespace}.json5`
          ))
      )
    )
    .use(LngDetector)
    .init(i18nOptions);

export const i18nOptions: InitOptions = {
  ns: [
    'activity',
    'campaign.common',
    'common',
    'donations',
    'fitness',
    'fundraising.edit',
    'occasion.birthday',
    'occasion.common',
    'occasion.in_memory',
    'occasion.other',
    'occasion.wedding',
    'occasion',
    'settings',
    'updates',
    'milestones',
    'edit',
  ],
  defaultNS: 'common',
  supportedLngs: ['en', 'en-GB', 'en-US'],
  fallbackLng: 'en',
  debug: false,
  interpolation: {
    escapeValue: false,
  },
  detection: {
    order: ['querystring', 'navigator'],
    lookupQuerystring: 'locale',
  },
};
